import fieldOfCareData from '@/data/fields.json'
import mixins from '@/mixins.js'

const CHANGE_FIELD = (context, fieldID) => {
  context.commit('RESET_STATE')
  context.commit('GENERATE_BY_ID_OBJECTS')
  context.commit('SET_DEFAULT_MTAB_PRICE')
  context.commit('UPDATE_SELECTED_FIELD', fieldID)

  const selectedField = mixins.getObjectWithIDFromArr(fieldOfCareData, fieldID)

  const extModsArray = selectedField.extensionsModules.included

  if (!extModsArray || extModsArray.length < 1) {
    return
  }
  for (const extMod of extModsArray) {
    context.commit('TOGGLE_EXTENSION_MODULE', { id: extMod })
  }
}

const ADJUST_ABI_TBI = context => {
  context.commit('ADJUST_ABI_TBI')
  context.commit('SYNC_DATA')
}

const READJUST_ABI_TBI = context => {
  context.commit('READJUST_ABI_TBI')
  context.commit('SYNC_DATA')
}

const TOGGLE_EXTENSION_MODULE = (context, payload) => {
  context.commit('TOGGLE_EXTENSION_MODULE', payload)
  context.commit('SYNC_DATA')
}

const TOGGLE_APPLICATION = (context, appID) => {
  context.commit('TOGGLE_APPLICATION', appID)
  context.commit('SYNC_DATA')
}

const TOGGLE_ACCESSORY = (context, accID) => {
  context.commit('TOGGLE_ACCESSORY', accID)
  context.commit('SYNC_DATA')
}

const SHOW_DIALOG_THANK_YOU = context => {
  context.commit('CLOSE_ALL_DIALOGS')
  context.commit('SHOW_DIALOG_THANK_YOU')
}

const SHOW_GENERIC_DIALOG = (context, content) => {
  context.commit('CLOSE_ALL_DIALOGS')
  context.commit('SHOW_GENERIC_DIALOG', content)
}

const SET_DATA_FROM_CODE = (context, dataFromCode) => {
  context.commit('SHOW_GENERIC_DIALOG', { text: 'We are loading your awesome <br />MESI mTABLET configuration ...', loading: true })
  // console.warn('CODE DATA: ', dataFromCode)

  for (const id of dataFromCode.selected.extensionsModules) {
    context.commit('TOGGLE_EXTENSION_MODULE', { id: id, addOnly: true })
    context.commit('SYNC_DATA')
  }

  for (const id of dataFromCode.selected.applications) {
    context.commit('TOGGLE_APPLICATION', id, true)
    context.commit('SYNC_DATA')
  }

  for (const id of dataFromCode.selected.accessories) {
    context.commit('TOGGLE_ACCESSORY', id, true)
    context.commit('SYNC_DATA')
  }

  context.commit('CHANGE_STEP', 'last')
  context.commit('COMPLETE_STEPS_ON_SHARE')

  const tm = setTimeout(() => {
    context.commit('CLOSE_GENERIC_DIALOG')
    clearTimeout(tm)
  }, 2000)
}

const INIT_DATA = (context) => {
  context.commit('GENERATE_BY_ID_OBJECTS')
  context.commit('SET_DEFAULT_MTAB_PRICE')
}

export default {
  CHANGE_FIELD,
  ADJUST_ABI_TBI,
  READJUST_ABI_TBI,
  TOGGLE_EXTENSION_MODULE,
  TOGGLE_APPLICATION,
  TOGGLE_ACCESSORY,
  SHOW_DIALOG_THANK_YOU,
  SHOW_GENERIC_DIALOG,
  SET_DATA_FROM_CODE,
  INIT_DATA
}
